import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  useToast
} from '@chakra-ui/react';
import Form from '@rjsf/chakra-ui';
import validator from "@rjsf/validator-ajv8";
import { reverseTransformData, transformData } from '../../../util/helper';
import { getEventMasterlistIntroductionData, updateEventMasterlistData } from '../../../services/EventMasterlist';
import { RjsfSubmitButton } from '../../../RJSFCommonSchemas';
import FormLoader from '../../../CommonComponents/FormLoader';
import { showErrorToast, showSuccessToast } from "../../../util/errorHandler";


const Venue = () => {
  const { alias } = useParams();
  const [processedData, setProcessedData] = useState({});
  const [quickSave, setQuickSave] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();


  const schema = {
    "title": "",
    "description": "",
    "type": "object",
    "properties": {
      venue: {
        "type": "string",
        "title": "Venue",
      }
    }
  }

  const uiSchema = {
    ...RjsfSubmitButton(isSubmitting),
    venue: { "ui:emptyValue": "", "ui:widget": 'textarea' },
  };


  // Fetch initial data
  useEffect(() => {
    const getVenueData = async () => {
      try {
        if (alias) {
          const result = await getEventMasterlistIntroductionData(alias, 'venue');
          if (result) {
            const fieldsToTransform = [
            ];
            setProcessedData(transformData(result?.[0], fieldsToTransform));
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
                showErrorToast(toast, "Failed to fetch data");
      } finally {
        setIsLoading(false);
      }
    };

    getVenueData();
  }, [alias, toast, quickSave]);

  // Submit updated data
  const handleSubmit = async (formData) => {

    const updatedFormData = reverseTransformData(formData, []);

    try {
      if (alias) {
        setIsSubmitting(true);
        const result = await updateEventMasterlistData(alias, updatedFormData);

        if (result?.success) {
          setQuickSave(prev => !prev);
                    showSuccessToast(toast, "Data updated successfully");
        }
      }
    } catch (error) {
      console.error('Error updating data:', error);
            showErrorToast(toast, "Failed to update data");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box maxW="auto">
      {isLoading ? (
        <FormLoader />
      ) : (
          <Form schema={schema} uiSchema={uiSchema} formData={processedData} validator={validator} onSubmit={(e) => handleSubmit(e.formData)} />
      )}
    </Box>
  );
};

export default Venue;